function Name({ value, handleValue }) {
   return (
      <div className="group">
         <label htmlFor="fullname">Full Name</label>
         <input
            type="text"
            id="fullname"
            required
            autoComplete="off"
            placeholder="e.g. John Doe"
            value={value}
            onChange={e => handleValue(e.target.value, 'fullname')}
         />
      </div>
   )
}

export default Name
